import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.min.js"
import i18n from './i18n'; //  يحمّل إعداد الترجمة

i18n.on("languageChanged", (lng) => {
  if (lng === "ar") {
    document.body.classList.add("ltr");
    //document.body.classList.remove("ltr");
  } else {
    document.body.classList.add("ltr");
    //document.body.classList.remove("rtl");
  }
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
